import React from 'react';
import { X } from 'lucide-react';
interface MessageModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  type?: 'success' | 'error' | 'info';
}
export function MessageModal({
  isOpen,
  onClose,
  title,
  message,
  type = 'info'
}: MessageModalProps) {
  if (!isOpen) return null;
  const bgColor = type === 'success' ? 'bg-green-50 border-green-200' : type === 'error' ? 'bg-red-50 border-red-200' : 'bg-blue-50 border-blue-200';
  return <div data-testid="message-modal-overlay" className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-605">
      <div data-testid="message-modal" data-message-type={type} className="bg-white border border-gray-300 max-w-md w-full shadow-lg" data-id="element-606">
        <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-607">
          <h3 data-testid="message-modal-title" className="font-bold text-lg" data-id="element-608">
            {title}
          </h3>
          <button data-testid="message-modal-close-btn" onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-609">
            <X className="w-5 h-5" data-id="element-610" />
          </button>
        </div>
        <div className={`p-6 border-l-4 ${bgColor}`} data-id="element-611">
          <p data-testid="message-modal-content" className="text-sm text-gray-700" data-id="element-612">
            {message}
          </p>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-613">
          <button data-testid="message-modal-ok-btn" onClick={onClose} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-614">
            Close
          </button>
        </div>
      </div>
    </div>;
}